var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-col',[_c('SMSCharges',{attrs:{"route":"products.feed.smscharges","isFeed":true,"product":_vm.feedProduct}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }